var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01Youtube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ea0029;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 11.5,
    cy: 11.5,
    r: 11.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M752.74,492.94l-4.66,2.74V490.2Zm4.36,2.54v-5.09a2.41,2.41,0,0,0-2.45-2.46h-9.34a2.4,2.4,0,0,0-2.45,2.46v5.09a2.4,2.4,0,0,0,2.45,2.45h9.34a2.4,2.4,0,0,0,2.45-2.45",
    transform: "translate(-738.48 -481.39)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01Youtube);
export default __webpack_public_path__ + "static/media/01_Youtube.f72554134052f89d180d4cf96c0859ed.svg";
export { ForwardRef as ReactComponent };